// CSS
import 'awesomplete/awesomplete.css';
// JS
import awesomplete  from 'awesomplete';

const initializeAuthorSearch = () => {
    let authorTextField = document.querySelector("#author");
    let authorSearchForm = document.querySelector("#authorSearchForm");

    if (!authorTextField) {
        return;
    }

    const awesomplete = new Awesomplete(authorTextField, {minChars: 3});

    /** Ajax a new request for posts */
    function ajaxResults() {
        let term = authorTextField.value;
        // console.log("getting ajaxResults for term: " + term);

        if (term.length !== 0) {
            const endpointURL = window.location.pathname + "Prefixes/" + term;
            const ajax = new XMLHttpRequest();
            ajax.open('GET', endpointURL, true);

            ajax.onload = () => {
                let list = [];
                if (200 === ajax.status) {
                    list = JSON.parse(ajax.responseText);
                    awesomplete.list = list;
                }
            };
            ajax.send();
        }
    }

    authorTextField.addEventListener('input', ajaxResults);
    authorTextField.addEventListener('awesomplete-selectcomplete', function () {
        authorSearchForm.submit();
    });
}

document.addEventListener('DOMContentLoaded', initAuthorsPage);

function initAuthorsPage() {
    initializeAuthorSearch();
}
